import CustomLeafletControl from 'components/BaseMap/components/CustomLeafletControl';
import { FaSearchMinus } from 'react-icons/fa';
import { useMap } from 'react-leaflet';

export default function ResetZoomControl({ zoomLevel = 3 }) {
  const map = useMap();

  const handleResetZoom = () => {
    const targetZoom = Number(zoomLevel);
    if (!map || !Number.isFinite(targetZoom)) return;
    map.setZoom(targetZoom, { animate: true });
  };

  return (
    <CustomLeafletControl position="topleft">
      <div className="leaflet-bar bg-white">
        <button
          type="button"
          className="btn btn-light d-flex align-items-center justify-content-center p-0"
          style={{ width: 30, height: 30, borderRadius: 4 }}
          onClick={handleResetZoom}
          aria-label={`Reset zoom`}
          title={`Reset zoom`}
        >
          <FaSearchMinus size={13} />
        </button>
      </div>
    </CustomLeafletControl>
  );
}
